// Subida de archivos sin multipart (oct 2026).
//
// El nginx del hosting rechaza con 403 cualquier POST multipart/form-data y con
// 413 los pedidos de mas de ~8 MB: el pedido no llega al backend. Por eso el
// FormData que va a /api/ se convierte en JSON con los archivos en base64, y el
// backend lo vuelve a armar (backend/middleware/multer-json.js).
//
// Los archivos que no entran en ese pedido se suben antes en partes binarias a
// /api/subidas y en el JSON viajan como { subida: id } (services/subidas-temp).
//
// Se aplica en un solo lugar: el interceptor de fetch y las instancias de
// axios. Las pantallas siguen armando su FormData como siempre.

const API = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

// Bytes de archivo que viajan en base64 dentro del pedido (+33 % al codificar,
// bien por debajo del limite de nginx). Lo que no entra va por /api/subidas.
const EN_LINEA_BYTES = 4 * 1024 * 1024;

export function debeConvertir(url, body) {
  return typeof FormData !== 'undefined' && body instanceof FormData &&
    String(url || '').includes('/api/');
}

function base64De(blob) {
  return new Promise((resolve, reject) => {
    const lector = new FileReader();
    lector.onload = () => resolve(String(lector.result).split(',')[1] || '');
    lector.onerror = () => reject(lector.error);
    lector.readAsDataURL(blob);
  });
}

async function respuestaJson(res, accion) {
  let data = {};
  try { data = await res.json(); } catch { /* la pagina de error de nginx no es JSON */ }
  if (!res.ok) throw new Error(data.error || `No se pudo ${accion} (${res.status})`);
  return data;
}

// window.fetch pasa por el interceptor: pone el token y renueva la sesion.
async function subirEnPartes(blob) {
  const inicio = await window.fetch(`${API}/subidas`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ tamano: blob.size }),
  });
  const { id, parte } = await respuestaJson(inicio, 'iniciar la subida del archivo');

  for (let desde = 0; desde < blob.size; desde += parte) {
    const res = await window.fetch(`${API}/subidas/${id}?offset=${desde}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/octet-stream' },
      body: blob.slice(desde, desde + parte),
    });
    await respuestaJson(res, 'subir el archivo');
  }
  return id;
}

export async function formDataAJson(fd) {
  const campos = [];
  const archivos = [];
  let enLinea = 0;
  for (const [nombre, valor] of fd.entries()) {
    if (!(valor instanceof Blob)) {
      campos.push([nombre, valor]);
      continue;
    }
    const archivo = {
      campo: nombre,
      nombre: valor.name || 'archivo',
      tipo: valor.type || 'application/octet-stream',
    };
    if (enLinea + valor.size <= EN_LINEA_BYTES) {
      enLinea += valor.size;
      archivo.base64 = await base64De(valor);
    } else {
      archivo.subida = await subirEnPartes(valor);
    }
    archivos.push(archivo);
  }
  return { __formdata: 1, campos, archivos };
}

export function instalarEnAxios(instancia) {
  instancia.interceptors.request.use(async (config) => {
    const url = `${config.baseURL || ''}${config.url || ''}`;
    if (!debeConvertir(url, config.data)) return config;
    config.data = await formDataAJson(config.data);
    config.headers['Content-Type'] = 'application/json';
    return config;
  });
  return instancia;
}
